export enum ApexPerformanceHorizon {
    '1M' = '1M',
    '3M' = '3M',
    '6M' = '6M',
    '1Y' = '1Y',
    ALL = 'ALL',
}

export const APEX_PERFORMANCE_HORIZONS: readonly ApexPerformanceHorizon[] = [
    ApexPerformanceHorizon['1M'],
    ApexPerformanceHorizon['3M'],
    ApexPerformanceHorizon['6M'],
    ApexPerformanceHorizon['1Y'],
    ApexPerformanceHorizon.ALL,
];

export interface ApexPerformanceDatapoint {
    step: string;
    netContribution: number;
    accountValuation: number;
}

export interface ApexAccountPerformanceSeriesItem {
    horizon: ApexPerformanceHorizon;
    amountReturn: number;
    percentageReturn: number | null;
    datapoints: ApexPerformanceDatapoint[];
}

export interface ApexAccountAllTimePerformance {
    deposits: number;
    withdrawals: number;
    dividends: number;
}

export type GetApexPerformanceResponse = Record<
    ApexPerformanceHorizon,
    ApexAccountPerformanceSeriesItem
> & {
    lastDataAt?: string;
};
